<table>
	<thead>
		<tr>
			<td>
				<div class="header-space">&nbsp;</div>
			</td>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>
				<div class="content">
					<slot />
				</div>
			</td>
		</tr>
	</tbody>
	<tfoot>
		<tr>
			<td>
				<div class="footer-space">&nbsp;</div>
			</td>
		</tr>
	</tfoot>
</table>
<header class="header">
	<p>Lenex Splits Sheet Creator</p>
</header>
<footer class="footer">
	<p>Lenex Splits Sheet Creator</p>
	<p>&copy; Tim Bachmann
		<a href="https://tiim.ch">tiim.ch</a>
	</p>
</footer>


<style>
  .header,
  .header-space,
  .footer,
  .footer-space {
    height: 1rem;
  }
  .header,
  .footer {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    left: 0px;
    width: calc(100vw - 4rem);
    padding: 0rem 2rem;
  }
  .header > p,
  .footer > p {
    margin: 0px;
  }
  .header {
    position: fixed;
    top: 0;
    align-items: flex-start;
  }
  .footer {
    position: fixed;
    bottom: 0;
    align-items: flex-end;
  }
</style>